/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_FridgesInputs */

const he_home_category_fridges = /** @type {(inputs: Home_Category_FridgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מקררים`)
};

const en_home_category_fridges = /** @type {(inputs: Home_Category_FridgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fridges`)
};

/**
* | output |
* | --- |
* | "Fridges" |
*
* @param {Home_Category_FridgesInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_fridges = /** @type {((inputs?: Home_Category_FridgesInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_FridgesInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_fridges(inputs)
	return en_home_category_fridges(inputs)
});